import ReactDOM from "react-dom/client"

import App from "./App"

import "~/lang/index"

import Providers from "~/components/Providers"

ReactDOM.createRoot(document.getElementById("root") as HTMLElement).render(
  <Providers>
    {/*<Suspense fallback={<div>Loading...</div>}>*/}
    <App />

    {/*</Suspense>*/}
  </Providers>,
)
